module.exports = __webpack_public_path__ + "img/fedukova.bae3209c.jpg";